import { BankTransferFormModel } from '@/modules/banking/models'

const ACTION_PREFIX = 'banking/bankTransfer'
const HIDE_DRAWER = `${ACTION_PREFIX}/hideDrawer`
const SHOW_DRAWER = `${ACTION_PREFIX}/showDrawer`
const SET_FORM_DATA = `${ACTION_PREFIX}/setFormData`
const RESET_FORM_DATA = `${ACTION_PREFIX}/resetFormData`

const initialState = {
  data: new BankTransferFormModel(),
  open: false,
}

export default function bankTransferReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_DRAWER: {
      return { ...state, open: true }
    }
    case HIDE_DRAWER: {
      return { ...state, open: false }
    }
    case SET_FORM_DATA: {
      const { data } = action
      return { ...state, data: new BankTransferFormModel({ ...state.data, ...data }) }
    }
    case RESET_FORM_DATA: {
      return { ...state, data: new BankTransferFormModel() }
    }
    default: {
      return state
    }
  }
}

export const hideBankTransferDrawer = () => ({ type: HIDE_DRAWER })
export const showBankTransferDrawer = () => ({ type: SHOW_DRAWER })
export const setBankTransferFormData = (data) => ({ type: SET_FORM_DATA, data })
export const resetBankTransferFormData = () => ({ type: RESET_FORM_DATA })
